module.exports = __webpack_public_path__ + "img/clear-search-criteria.f3518129.svg";